import * as React from 'react'

import style from '@/views/FoodGrubhubRestaurantDetail/FoodGrubhubRestaurantDetail.module.scss'

interface ReadMoreListProps {
  items: string[]
  maxVisible?: number
  viewMoreTitle?: string
  viewLessTitle?: string
}

const ReadMoreList: React.FC<ReadMoreListProps> = ({
  items,
  maxVisible = 5,
  viewMoreTitle = 'Read more',
  viewLessTitle = 'Read less',
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const visibleItems = isExpanded ? items : items.slice(0, maxVisible)
  const hasMore = items.length > maxVisible

  return (
    <div role='list' aria-label='List of cuisines' className={style.CuisineList}>
      {visibleItems.map((cuisine, index) => (
        <div key={cuisine} role='listitem' className={style.CuisineItem}>
          <div className={style.CuisineItemTitle}>{cuisine}</div>
          {index !== visibleItems.length - 1 && (
            <div className={style.CuisineItemBreak} aria-hidden='true' />
          )}
        </div>
      ))}

      {hasMore && (
        <button
          onClick={() => {
            setIsExpanded(prev => !prev)
          }}
          className={style.ReadMore}
          type='button'
        >
          {isExpanded ? viewLessTitle : viewMoreTitle}
        </button>
      )}
    </div>
  )
}

export default ReadMoreList
